module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-3.8d590e4e.jpg";